import { TenantCustomization } from "../TenantCustomization.ts";
import { handleBmwRsUrlChange } from "./interactions.ts";

const BMW_RS: TenantCustomization = {
    getButtonElement: () => document.getElementsByClassName("chatbot-button")?.[0] as HTMLDivElement,
    getInteractionTagNames: () => null,
    getUrlListener: handleBmwRsUrlChange,
};
export default BMW_RS;
